﻿(function (angular, ToyotaConsts) {
  "use strict";

  var PAINT_LIST_COLOUR_MATCHER_MINIMUM_PERCENT_MATCH = 0.8;

  angular.module("Toyota.Factories").factory("RangePaintApi", [
    "DebugLogger",
    "$q",
    "$filter",
    "API",
    "PaintListColourMatcher",
    function (DebugLogger, $q, $filter, API, PaintListColourMatcher) {
      function getByMaterialCode(materialCode, pricingParams) {
        if (pricingParams) {
          // This service looks up usageType by itself, so we don't need to pass usageType
          return API.get(
            $filter("formatArgs")(ToyotaConsts.API.Vehicle.PaintByMaterialCodeWithPricingOptions, [
              materialCode,
              pricingParams.postcode,
            ])
          ).then(function (response) {
            if (!response.data.success) {
              DebugLogger.log(
                "RangePaintApi",
                "getByMaterialCode (with pricing params): server responded with falsy success"
              );
              throw new Error(
                "RangePaintApi.getByMaterialCode (with pricing params): server responded with falsy success"
              );
            }

            return response.data;
          });
        }

        return API.get($filter("formatArgs")(ToyotaConsts.API.Vehicle.PaintByMaterialCode, [materialCode])).then(
          function (response) {
            if (!response.data.success) {
              DebugLogger.log(
                "RangePaintApi",
                "getByMaterialCode (no pricing params): server responded with falsy success"
              );
              throw new Error(
                "RangePaintApi.getByMaterialCode (no pricing params): server responded with falsy success"
              );
            }

            return response.data;
          }
        );
      }

      var schemas = {
        rangeSpinner: {
          getDescription: function (bodyOrRoofPaint) {
            return bodyOrRoofPaint.name;
          },
          getHexCode: function (bodyOrRoofPaint) {
            return bodyOrRoofPaint.hexCode;
          },
        },
        rangeOther: {
          getDescription: function (bodyOrRoofPaint) {
            return bodyOrRoofPaint.RoofPaintDescription || bodyOrRoofPaint.BodyPaintDescription;
          },
          getHexCode: function (bodyOrRoofPaint) {
            return bodyOrRoofPaint.RoofPaintSwatchHex || bodyOrRoofPaint.BodyPaintSwatchHex;
          },
        },
      };

      function getClosestBodyPaint(bodyPaintDescription, bodyPaintHex, bodyPaints, schema) {
        DebugLogger.log("RangePaintApi", "getClosestBodyPaint started", bodyPaintDescription, bodyPaintHex, bodyPaints);

        /* eslint-disable no-param-reassign */
        schema = schema || schemas.rangeOther;
        /* eslint-enable no-param-reassign */

        var paintExist = bodyPaints.findIndex(bodyPaint => bodyPaint.bodyPaintName === bodyPaintDescription);

        if (paintExist > -1) {

          var closestColourTuple = PaintListColourMatcher({
            colourTuples: bodyPaints.map(function (i) {
              return { description: schema.getDescription(i), hex: schema.getHexCode(i) };
            }),
          }).closestMatch(
            { description: bodyPaintDescription, hex: bodyPaintHex },
            PAINT_LIST_COLOUR_MATCHER_MINIMUM_PERCENT_MATCH
          );

          var matchingClosestBodyPaints = [];

          if (closestColourTuple) {
            matchingClosestBodyPaints = bodyPaints.filter(function (bodyPaint) {
              return schema.getDescription(bodyPaint) === closestColourTuple.description;
            });
          }
        }

        var result = matchingClosestBodyPaints && matchingClosestBodyPaints.length ? matchingClosestBodyPaints[0] : bodyPaints[0];
        DebugLogger.log("RangePaintApi", "getClosestBodyPaint returning", result);
        return result;
      }

      // separate function because we don't have access to hex values for the roof paints at the moment
      function getClosestRoofPaint(roofPaintDescription, roofPaints, schema) {
        DebugLogger.log("RangePaintApi", "getClosestRoofPaint started", roofPaintDescription, roofPaints);

        /* eslint-disable no-param-reassign */
        schema = schema || schemas.rangeOther;
        /* eslint-enable no-param-reassign */

        var matchingClosestRoofPaints = roofPaints.filter(function (roofPaint) {
          return schema.getDescription(roofPaint) === roofPaintDescription;
        });
        var result = matchingClosestRoofPaints.length ? matchingClosestRoofPaints[0] : roofPaints[0];
        DebugLogger.log("RangePaintApi", "getClosestRoofPaint returning", result);
        return result;
      }

      return {
        getByMaterialCode: getByMaterialCode,
        getClosestBodyPaint: getClosestBodyPaint,
        getClosestRoofPaint: getClosestRoofPaint,
        schemas: schemas,
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
